import { useQuery, requestDeals } from '@workspace/api';

export interface Realisateur {
    belair_id: number;
    name: string;
}

/**
 * Hook pour récupérer la liste des réalisateurs ADM (télévente) depuis le Pass.
 * Réservé aux rôles admin / manager télévente côté API.
 */
export function useRealisateurs(enabled = true) {
    return useQuery<{ data: Realisateur[] }>({
        queryKey: ['deals', 'realisateurs'],
        queryFn: async () => {
            const response = await requestDeals.get<{ data: Realisateur[] }>('/api/realisateurs');
            return response.data;
        },
        enabled,
        staleTime: 60 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
    });
}
